const splitByNewLine = (stringData) => {
  return stringData.split("\n");
};
export default splitByNewLine;
